export function textEncodeBase64(plainText: string) {
  if (!plainText) {
    return plainText;
  }

  const encoder = new TextEncoder();
  const charCodes = encoder.encode(plainText);
  const stringFromChars = String.fromCharCode(...charCodes);
  return btoa(stringFromChars);
}
